// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__reFgg","body":"NotFound_body__sQB+C"};